import { createAsyncThunk } from "@reduxjs/toolkit";
import { getRecaptchaToken } from "utils/auth";
import apiRequest from "../../../services/api";

// Login api
export const VerifyCredentials = createAsyncThunk(
  "auth/login",
  async (body, { rejectWithValue }) => {
    try {
      const api = await apiRequest.post("v2/login/", {
        ...body,
      });
      return api.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue({
        ...err.response.data,
        status: err.response.status,
      });
    }
  }
);

export const getOTP = createAsyncThunk(
  "auth/getOTP",
  async (body, { rejectWithValue }) => {
    try {
      const recaptcha = await getRecaptchaToken("login");
      const api = await apiRequest.post("v2/login/get_otp/", {
        ...body,
        recaptcha: recaptcha,
      });
      return api.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue({
        ...err.response.data,
        status: err.response.status,
      });
    }
  }
);

// Forgot password - request
export const changePassword = createAsyncThunk(
  "auth/requestChangePasswordOtp",
  async (body, { rejectWithValue }) => {
    try {
      const api = await apiRequest.post("v1/forgot_password/", body);
      return api.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue({
        ...err.response.data,
        status: err.response.status,
      });
    }
  }
);

// Forgot password - verify
export const forgotPasswordVerify = createAsyncThunk(
  "auth/verifyChangePasswordOtp",
  async (body, { rejectWithValue }) => {
    try {
      const api = await apiRequest.post("v1/forgot_password/verify/", body);
      return api.data;
    } catch (err) {
      if (!err.response) {
        throw err;
      }
      return rejectWithValue({
        ...err.response.data,
        status: err.response.status,
      });
    }
  }
);
